import { api } from '../../api'
import { GetContractsByCarrierResponse } from '../../types'

interface GetContractsByCarrierParams {
  carrierId: number
  sapItemId?: number
}

const getContractsByCarrierId = async (params: GetContractsByCarrierParams) => {
  const response = await api.post<GetContractsByCarrierResponse>('/sap-items/contracts', params)
  return response.data.contracts
}

export { getContractsByCarrierId }
